





















































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { DataTableHeader } from 'vuetify';
import { area as turfArea } from '@turf/turf';
import { useGroups } from '@/store/modules/group';
import { Field } from '@/store/types';
import { SQUARE_METERS_PER_HECTARE } from '../../constants';
import FieldReassign from '../admin/FieldReassign.vue';
import StratifyButton from '../stratify/StratifyButton.vue';
import FieldBulkDeleteButton from './FieldBulkDeleteButton.vue';
import FieldDeleteButton from './FieldDeleteButton.vue';

interface FieldsTableRow extends Pick<Field, 'id' | 'name'> {
	groupPath: string;
	lastUpdated: string | null;
	area: string;
	status: string;
}

export default defineComponent({
	components: { FieldReassign, FieldDeleteButton, StratifyButton, FieldBulkDeleteButton },
	props: {
		isLoading: {
			type: Boolean,
		},
		isLoaded: {
			type: Boolean,
		},
		hasError: {
			type: Boolean,
		},
		fields: {
			type: Array as () => Field[],
			default: [],
		},
	},
	setup(props, { root }) {
		const search = ref<string>('');
		const { isLoading: groupsAreLoading, isLoaded: groupsAreLoaded, hasError: groupsHaveError, groups } = useGroups(
			root.$store
		);
		const page = ref<number>(1);
		const sortBy = ref<string[]>(['lastUpdated']);
		const sortDesc = ref<boolean[]>([true]);
		const selectedRows = ref<FieldsTableRow[]>([]);
		const selectedFieldIds = computed(() => selectedRows.value.map((field: FieldsTableRow) => field.id));

		const headers: DataTableHeader[] = [
			{ text: 'ID', value: 'id' },
			{ text: 'Name', value: 'name' },
			{ text: 'Group', value: 'groupPath' },
			{ text: 'Area (ha)', value: 'area' },
			{ text: 'Status', value: 'status' },
			{ text: 'Last Updated', value: 'lastUpdated' },
			{ text: '', value: 'actions', sortable: false },
		];

		const tableData = computed<FieldsTableRow[]>(() =>
			props.fields.map(({ id, name, meta }) => {
				const groupPath = root.$store.getters['groups/getGroupPathById'](meta.groupId) || 'no group';
				const status = root.$store.getters['resources/getFieldStatusById'](id);
				const area = root.$store.getters['resources/getAreasByFieldId'](id)?.[0];
				const areaInSquareMeters = area ? turfArea(area) : 0;
				const areaInHectares = (areaInSquareMeters / SQUARE_METERS_PER_HECTARE).toFixed(2);

				return {
					id,
					name,
					groupPath,
					area: areaInHectares,
					status: status.state,
					lastUpdated: status ? status.timestamp : null,
				};
			})
		);

		const getFieldFromTableRow = (row: FieldsTableRow) => props.fields.find((field) => field.id === row.id);
		const handleDeleteSuccess = (deletedFieldIds: string[]) => {
			selectedRows.value = selectedRows.value.filter((row) => !deletedFieldIds.includes(row.id));
		};

		watch(search, () => {
			page.value = 1;
		});

		return {
			page,
			search,
			sortBy,
			sortDesc,
			headers,
			tableData,
			groupsAreLoading,
			groupsAreLoaded,
			groupsHaveError,
			groups,
			getFieldFromTableRow,
			selectedRows,
			selectedFieldIds,
			handleDeleteSuccess,
		};
	},
});
